import React, { useContext, useEffect, useState } from "react"
import { TrashIcon, CollectionIcon, PlusIcon, ChatIcon, PencilIcon } from "@heroicons/react/outline"
import { EndpointConfig } from "../../config"
import { AuthContext } from "../../context/auth.context"
import { axiosInstance } from "../../lib/axios"
import { toast } from "react-toastify"
import Button from "../atoms/button.atom"
import Modal from "../atoms/modal.atom"
import { Header } from "../common/header"

export const DeliveryLogHandler = ({ hubId }) => {
	const { auth, setAuth } = useContext(AuthContext)
	const [deliveryLogs, setDeliveryLogs] = React.useState([])
	const [loading, setLoading] = React.useState(false)
	const [isModalVisible, setIsModalVisible] = React.useState(false)
	const [errors, setErrors] = React.useState({})
	const [showSuccess, setShowSuccess] = React.useState(false)

	const getDeliveryLogs = () => {
		setLoading(true)
		;(async () => {
			const res = await axiosInstance.get(EndpointConfig.VFDeliveryLogs, {
				headers: {
					"hub-id": hubId
				}
			})
			console.log("res", res)
			setDeliveryLogs(res.data.data || [])
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	React.useEffect(() => {
		console.log("Running UseEffect")
		getDeliveryLogs()
	}, [])

	return (
		<>
			<div className="flex flex-col">
				<Header IconName={CollectionIcon} subText={"List"} mainText={"Delivery Logs"} />

				<div className="flex flex-col pb-4 overflow-x-auto bg-white rounded">
					<div className="inline-block min-w-full py-2">
						<table className="common">
							<thead className="">
								<tr className="">
									{/* <th className="">Delivery Logs</th> */}
									<th className="">TO</th>
									<th className="">MSG STATUS</th>
									<th className="">CLIENT GUID</th>
									<th className="">STATUS REQUEST</th>
									<th className="">DELIVERED DATE</th>
									<th className="">TEXT STATUS</th>
									<th className="">MESSAGE ID</th>
									<th className="">CLIENT SEQ NUMBER</th>
									<th className="">TAG</th>
								</tr>
							</thead>
							<tbody>
								{deliveryLogs.map((log) => (
									<tr key={log._id}>
										{/* {<td className="">{log._id} </td>} */}
										<td className="font-medium">{JSON.parse(log.data).TO}</td>
										<td className="">{JSON.parse(log.data).MSG_STATUS}</td>
										<td className="">{JSON.parse(log.data).CLIENT_GUID}</td>
										<td className="">{JSON.parse(log.data).STATUS_ERROR}</td>
										<td className="">{JSON.parse(log.data).DELIVERED_DATE}</td>
										<td className="">{JSON.parse(log.data).TEXT_STATUS}</td>
										<td className="">{JSON.parse(log.data).MESSAGE_ID}</td>
										<td className="">
											{JSON.parse(log.data).CLIENT_SEQ_NUMBER}
										</td>
										<td className="">{JSON.parse(log.data).TAG}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
				{loading ? (
					<div className="text-xs font-bold text-blue-800 uppercase">loading...</div>
				) : null}
			</div>
		</>
	)
}
